<template>
  <div class="knowledgeFootprint">
    <div class="titleBox">
      <div class="redBox"></div>
      <p>我的知识足迹</p>
    </div>
    <div class="contair">
      <div class="left">
        <ul class="titleList">
          <li v-for="(item,index) in logTypes" :class="searchForm.logType==item.type?'activeLi':''" @click="choiceLogType(item)">
            <span>{{item.title}}({{item.number}})</span>
          </li>
        </ul>
      </div>
      <div class="right">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="快捷查询" name="1">
            <div class="timeBox">
              <div class="name">
                <div>知识名称</div>
                <div>
                  <el-input placeholder="请输入内容" v-model="searchForm.goodsName"></el-input>
                </div>
              </div>
              <div class="time">
                <div class="timeText">时间选择</div>
                <div class="pickData">
                  <el-date-picker v-model="searchdate" type="datetimerange" :picker-options="pickerOptions"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="searchBox">
              <div class="knowladge">
                <div>知识目录</div>
                <div>
                  <el-input v-model="searchForm.goodsCatalogueId" v-show="false">
                  </el-input>
                  <el-input placeholder="请选择" v-model="searchForm.goodsCatalogueIdName">
                    <el-button @click="showDialog('treeCatalogue');goodsCatalogueIdDialogVisible=true" slot="append" icon="el-icon-search"></el-button>
                  </el-input>
                </div>
              </div>
              <div class="knowladgeType">
                <div>知识分类</div>
                <div>
                  <el-input v-model="searchForm.goodsCategoryId" v-show="false">
                  </el-input>
                  <el-input placeholder="请选择" v-model="searchForm.goodsCategoryIdName">
                    <el-button @click="showDialog('treeCategory');goodsCategoryIdDialogVisible=true" slot="append" icon="el-icon-search"></el-button>
                  </el-input>
                </div>
              </div>
              <div class="btnBox">
                <button @click="resetSearchForm()">重置</button>
                <button @click="query()">查询</button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div class="topBox" >
          <p>温馨提醒: 显示最近浏览的知识。</p>
          <p></p>
        </div>
        <div class="content">

          <div class="leftContent"><!-- -->
            <el-tree :data="searchResultTreeData" :props="defaultProps" ref="searchResultTree" :highlight-current="true"
             :expand-on-click-node="false" @node-click="handleNodeClick" ></el-tree>
          </div>
          <div class="rightContent">
            <el-tabs v-model="statusSelected" @tab-click="handleStatuschange" type="card" class="rightDetail">
              <el-tab-pane v-for="(item, index) in status" :key="item.name" :name="item.value">
                <span slot="label">
                  <span>{{item.name}}</span>
                </span>
              </el-tab-pane>
            </el-tabs>
            <div class="resultContent" v-loading="searchLoading" v-bind:element-loading-text="searchLoadingText">
              <div v-for="item in searchResult">
                <div class="resuleBox" v-if="item.goodsUserBuyRecord&&item.goodsUserBuyRecord.id">
                  <!-- 已购买的 -->
                  <div class="timeAgo">
                    <p class="fn12">{{item.onShelvesDate | timeAgoLength}}</p>
                    <p class="fn12">{{item.onShelvesDate | substring(3)}}</p>
                  </div>
                  <div class="image hand" @click="showDetail(item.id,'3')">
                    <img v-if="item.showPicPath" v-bind:src="''+$store.state.defaultPicUrl+item.showPicPath+''" />
                    <img v-else src="@/assets/images/shebei1.png" />
                  </div>
                  <p class="fn14 margin0  hand" @click="showDetail(item.id,'3')" >{{item.name}}</p>
                  <!-- <span class="typeName hand" @click="showDetail(item.id,'3')" >{{item.name}}</span>
                  <p class="fn14 margin0 ">{{item.goodsCatalogueId.name}}</p> -->
                  <div class="logoType">
                    <!-- 已购买图标 -->
                    <img src="@/assets/images/Purchased.png">
                  </div>
                </div>

                <div class="resuleBox" v-else-if="!(item.goodsUserBuyRecord&&item.goodsUserBuyRecord.id)">
                  <!-- 未购买的 -->
                  <div class="timeAgo">
                    <p class="fn12">{{item.onShelvesDate | timeAgoLength}}</p>
                    <p class="fn12">{{item.onShelvesDate | substring(3)}}</p>
                  </div>
                  <div class="image hand" @click="showDetail(item.id,'2')">
                    <img v-if="item.showPicPath" v-bind:src="''+$store.state.defaultPicUrl+item.showPicPath+''" />
                    <img v-else src="@/assets/images/shebei1.png" />
                  </div>
                  <p class="fn14 margin0  hand" @click="showDetail(item.id,'2')" >{{item.name}}</p>
                  <!-- <span class="typeName hand" @click="showDetail(item.id,'2')" >{{item.name}}</span>
                  <p class="fn14 margin0 ">{{item.goodsCatalogueId.name}}</p> -->
                </div>

                <div class="OnTrial flexRow" v-if="item.goodsUserBuyRecord&&item.goodsUserBuyRecord.id">
                  <!-- 已购买  -->
                  <div class="flex1 bgcolor1">{{ item.goodsUserBuyRecord.endUseTime  | substring(3)}}前</div>
                  <div class="obliqueLine"></div>
                  <div class="bgcolor">可使用<span style="font-size: 16px;">{{ item.goodsUserBuyRecord.notUsedNumber }}</span>次</div>
                </div>

                <div class="OnTrial " v-else-if="!(item.goodsUserBuyRecord&&item.goodsUserBuyRecord.id)">
                  <!-- 未购买 -->
                  <!-- <div class="flex1 bgcolor2">&yen;{{item.goodsPriceInfo.price}} </div>
                  <div class="obliqueLine1"></div>
                  <div class="price">&yen;{{item.goodsPriceInfo.realPrice}}</div> -->

                  <div class="flexRow" v-if="item.goodsPriceInfo.priorityLevel=='1'">
                    <div class="flex1 bgcolor2">扫描二维码后使用</div>
                    <div class="obliqueLine1"></div>
                    <div class="price">&yen;{{item.goodsPriceInfo.price}}</div>
                  </div>
                  <div class="flexRow" v-else-if="item.goodsPriceInfo.priorityLevel=='10'">
                    <div class="flex1 bgcolor2">完善信息后使用</div>
                    <div class="obliqueLine1"></div>
                    <div class="price">&yen;{{item.goodsPriceInfo.price}}</div>
                  </div>
                  <div class="flexRow" v-else-if="item.goodsPriceInfo.priorityLevel=='15'">
                    <div class="flex1 bgcolor2">免费试用</div>
                    <div class="obliqueLine1"></div>
                    <div class="price">&yen;{{item.goodsPriceInfo.price}}</div>
                  </div>
                  <div class="flexRow" v-else-if="item.goodsPriceInfo.priorityLevel=='20'">
                    <div class="flex1 bgcolor2">购买使用</div>
                    <div class="obliqueLine1"></div>
                    <div class="price">&yen;{{item.goodsPriceInfo.price}}</div>
                  </div>
                  <div class="flexRow" v-else>
                    <div class="flex1 bgcolor2">&yen;{{item.goodsPriceInfo.price}} </div>
                    <div class="obliqueLine1"></div>
                    <div class="price">&yen;{{item.goodsPriceInfo.realPrice}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="paging">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" @prev-click="handlePrevClick"
                @next-click="handleNextClick" :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>


        </div>

      </div>
    </div>

    <el-dialog title="知识目录" :visible.sync="goodsCatalogueIdDialogVisible" width="30%">
      <div class="el-dialog-div">
        <el-input placeholder="输入关键字进行过滤" v-model="filterTextCatalogue">
        </el-input>
        <el-tree class="filter-tree" :data="goodsCatalogueData" :props="defaultProps" default-expand-all
          :filter-node-method="filterNode" ref="treeCatalogue" node-key="id" :highlight-current="true">
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearSelectedNode('treeCatalogue')">清 空</el-button>
        <el-button type="primary" @click="getCurrentNode('treeCatalogue');goodsCatalogueIdDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="知识分类" :visible.sync="goodsCategoryIdDialogVisible" width="30%">
      <div class="el-dialog-div">
        <el-input placeholder="输入关键字进行过滤" v-model="filterTextCategory">
        </el-input>
        <el-tree class="filter-tree" :data="goodsCategoryData" :props="defaultProps" default-expand-all
          :filter-node-method="filterNode" ref="treeCategory" node-key="id" :highlight-current="true">
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearSelectedNode('treeCategory')">清 空</el-button>
        <el-button type="primary" @click="getCurrentNode('treeCategory');goodsCategoryIdDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  export default ({
    name: 'knowledgeFootprint',
    data() {
      return {
        //树形组件默认数据结构
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        //知识目录选择器
        goodsCatalogueIdDialogVisible: false,
        goodsCatalogueData: [], //知识目录树形结构数据
        filterTextCatalogue: '', //知识目录过滤文本

        //知识分类选择器
        goodsCategoryIdDialogVisible: false,
        goodsCategoryData: [], //知识分类树形结构数据
        filterTextCategory: '', //知识分类过滤文本

        //搜索结果树
        searchResultTreeData: [],
        searchResultTreeSelected: '',//搜索结果树选中值

        searchLoading: false, //列表遮罩
        searchLoadingText: "数据正在加载中，请稍等",
        searchdate: [], //日期范围数组
        searchForm: { //查询参数
          goodsName: '', //商品名称
          goodsCatalogueId: '', //商品目录
          goodsCatalogueIdName: '', //商品目录名称
          goodsCategoryId: '', //商品分类
          goodsCategoryIdName: '', //商品分类名称
          startDate: '', //访问时间开始
          endDate: '', //访问时间结束
          logType: '', //足迹类型
          goodsStatus: '', //商品状态
          pageSize: 10,
          pageNo: 1
        },
        searchResult: [], //查询结果列表数据
        currentPage: 1, //活动页号
        pageSize: 10, //页码大小
        total: 0, //全部/分页数据总数
        statusSelected: '', //商品状态选择
        status: [{ //商品状态  全部 已购买  未购买 已过期 已下架
          name: "全部",
          value: "all"
        }, {
          name: "已购买",
          value: "ygm"
        }, {
          name: "未购买",
          value: "wgm"
        }, {
          name: "已过期",
          value: "ygq"
        }, {
          name: "已下架",
          value: "yxj"
        }],
        //足迹类型数组
        logTypes: [{ //title名称  type类型  number 记录数量
          title: '知识足迹',
          type: 'logs_goods_access',
          number: '0'
        }, {
          title: '已购知识',
          type: 'goods_user_buy_record',
          number: '0'
        }, {
          title: '热门知识(待完成)',
          type: 'logs_goods_hot', //暂无
          number: '0'
        }, {
          title: '知识建议',
          type: 'logs_goods_suggestion', //暂无
          number: '0'
        },
        // {
        //   title: '知识评论',
        //   type: 'logs_goods_feedback',
        //   number: '0'
        // }, {
        //   title: '网站留言',
        //   type: 'website_message', //暂无
        //   number: '0'
        // },
        // {
        //   title: '知识收藏',
        //   type: 'logs_goods_collection',
        //   number: '0'
        // }, {
        //   title: '知识点赞',
        //   type: 'logs_goods_praise',
        //   number: '0'
        // }, {
        //   title: '知识评价', //星级评分
        //   type: 'logs_goods_rate',
        //   number: '0'
        // }
      ],
        //日期快捷选择参数
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        searchResult: [],
        isShowSearch: false, //是否展示搜索区域，默认隐藏
        activeNames: ['']
      }
    },

    watch: {
      //监听查询日期
      searchdate: function(newVal, oldVal) {
        if (newVal && newVal.length > 0) {
          this.searchForm.startDate = newVal[0].getTime();
          this.searchForm.endDate = newVal[1].getTime();
        } else {
          this.searchForm.startDate = '';
          this.searchForm.endDate = '';
        }
      },
      filterTextCatalogue(val) {
        this.$refs.treeCatalogue.filter(val);
      },filterTextCategory(val) {
        this.$refs.treeCategory.filter(val);
      }
    },
    created: function() {

      //0.获取当前账号各种日志数量
      this.getLogTypsNumber();

      //1.重置查询参数
      this.resetSearchForm();

      //2.初始化加载消息列表
      this.query();

      //3.初始化页面查询参数数据员
      this.initSearchParams();
    },
    methods: {
      //重置查询参数
      resetSearchForm() {
        let selectLogType = this.searchForm.logType;
        if(!selectLogType){
          selectLogType = this.logTypes[0].type;
        }

        this.statusSelected = this.status[0].value;

        this.searchForm = { //查询参数
          goodsName: '', //商品名称
          goodsCatalogueId: '', //商品目录
          goodsCategoryId: '', //商品分类
          startDate: '', //访问时间开始
          endDate: '', //访问时间结束
          logType: selectLogType, //足迹类型
          goodsStatus: this.statusSelected, //商品状态
          pageSize: 10,
          pageNo: 1
        };

        this.searchdate = []; //重置日期范围选择器
      },
      //查询按钮触发
      query() {
        // console.log("====================查询参数========================");
        // console.log(this.searchForm);
        //清空搜索结果树选中值
        this.searchResultTreeSelected = '';
        this.queryMsgList();
      },
      //查询消息列表
      queryMsgList() {
        let this_ = this;
        this_.searchLoading = true;
        let paramdata = {};
        paramdata.data = this_.searchForm;
        paramdata.url = '/SJHG/publicplat/member/memberlog/searchGoodsList';
        // paramdata.url = '/SJHG/publicplat/home/home/searchGoodsList';
        //覆盖查询条件
        if(this.searchResultTreeSelected){
          paramdata.data.goodsCatalogueId = this.searchResultTreeSelected;
        }
        paramdata.onSuccess = function(res) {
          this_.searchLoading = false;
          // console.log('-------------足迹数据-----------------');
          // console.log(res);
          if (res.data.ok && res.data.result) {

            let list = [];
            let pageNo = 1;
            let pageSize = 10;
            let count = 0;

            let page_ = res.data.result.page; //全部
            //判断有无查询结果
            if (page_.count === undefined || !page_.count || page_.count === null || page_.count === 'null' ||
              page_.count ===
              0) {

            } else {
              list = page_.list;
              pageNo = page_.pageNo;
              pageSize = page_.pageSize;
              count = page_.count;
            }
            this_.searchResult = list;
            this_.currentPage = pageNo;
            this_.pageSize = pageSize;
            this_.total = count;

            //搜索结果树选中时不更搜索结果树
            if(this_.searchResultTreeSelected){

            }else{
              //搜索结果树
              let groupTree = res.data.result.groupTree;
              this_.searchResultTreeData = this_.getTreeData(groupTree);
            }


          } else {
            // let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
          }
        };
        paramdata.onFailed = function(res) {
          this_.searchLoading = false;
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      //--------------页脚分页
      handleSizeChange(val) {
        this.pageSize = val;

        this.searchForm.pageSize = val;
        this.query();
      },
      handleCurrentChange(val) {
        this.pageNo = val;
        this.searchForm.pageNo = val;
        this.query();
      },
      handlePrevClick(val) { //上一页
        this.pageNo = val;
        this.searchForm.pageNo = val;
        this.query();
      },
      handleNextClick(val) { //下一页
        this.pageNo = val;
        this.searchForm.pageNo = val;
        this.query();
      },
      //快捷查询显示控制
      hiddenSearch() {
        if (this.isShowSearch === true) {
          this.isShowSearch = false;
        } else {
          this.isShowSearch = true;
        }
      },
      //切换商品状态页签
      handleStatuschange: function(tab, event) {
        this.searchForm.goodsStatus = tab.name; //获取到当前元素的name
        this.query();
      },
      //切换足迹类型
      choiceLogType(item) {
        //1.重置查询参数
        this.resetSearchForm();
        this.searchForm.logType = item.type;
        this.query();
      },
      //商品目录树节点选择
      handleNodeClick(data) {
        // console.log(data);
      },
      showDetail(val, type) { //商品详情
        console.log(val, type);
        if (type === '1') {
          this.$router.push({
            path: "/algorithmDetail",
            query: {
              "id": val
            }
          });
        } else if (type === '2') {
          this.$router.push({
            path: "/toolKnowledgeDetails",
            query: {
              "id": val
            }
          });
        } else if (type === '3') {
          this.$router.push({
            path: "/toolKnowledgeDetails",
            query: {
              "id": val,
              "isbuy": "yes"
            }
          });
        }

      },
      //树形组件查找节点
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      //获取树形组件选中节点
      clearSelectedNode(treeName) {
        let nodekey = '';
        if (treeName == 'treeCatalogue') {
          nodekey = this.$refs.treeCatalogue.getCurrentKey();
          if (nodekey) {
            this.$refs.treeCatalogue.setCurrentKey();
          }
          //快捷查询-知识目录树
          this.searchForm.goodsCatalogueId = ''
          this.searchForm.goodsCatalogueIdName = ''
          this.filterTextCatalogue = '';
        } else if (treeName == 'treeCategory') {
          //快捷查询-知识分类树
          nodekey = this.$refs.treeCategory.getCurrentKey();
          if (nodekey) {
            this.$refs.treeCategory.setCurrentKey();
          }
          //快捷查询-知识目录树
          this.searchForm.goodsCategoryId = ''
          this.searchForm.goodsCategoryIdName = ''
          this.filterTextCategory = '';

        } else if (treeName == '') {
          //查询结果-知识目录树
        }

      },
      //获取树形组件选中节点
      getCurrentNode(treeName) {
        let node = {};
        if (treeName == 'treeCatalogue') {
          node = this.$refs.treeCatalogue.getCurrentNode();
          //快捷查询-知识目录树
          if (node&&node.id) {
            this.searchForm.goodsCatalogueId = node.id;
            this.searchForm.goodsCatalogueIdName = node.label;
          } else {
            this.searchForm.goodsCatalogueId = '';
            this.searchForm.goodsCatalogueIdName = '';
          }
        } else if (treeName == 'treeCategory') {
          //快捷查询-知识分类树
          node = this.$refs.treeCategory.getCurrentNode();
          //快捷查询-知识目录树
          if (node&&node.id) {
            this.searchForm.goodsCategoryId = node.id;
            this.searchForm.goodsCategoryIdName = node.label;
          } else {
            this.searchForm.goodsCategoryId = '';
            this.searchForm.goodsCategoryIdName = '';
          }
        } else if (treeName == '') {
          //查询结果-知识目录树
        }

      },
      //获取树形组件选中节点
      showDialog(treeName) {
        let nodekey = '';
        if (treeName == 'treeCatalogue') {
          //快捷查询-知识目录树
          nodekey = this.searchForm.goodsCatalogueId;
          if(nodekey){
            this.$refs.treeCatalogue.setCurrentKey(nodekey);
          }
        } else if (treeName == 'treeCategory') {
          //快捷查询-知识分类树
          nodekey = this.searchForm.goodsCategoryId;
          if(nodekey){
            this.$refs.treeCategory.setCurrentKey(nodekey);
          }
        } else if (treeName == '') {
          //查询结果-知识目录树
        }

      },
      //初始化页面查询参数数据员
      initSearchParams() {
        let this_ = this;
        let paramdata = {};
        paramdata.data = {};
        paramdata.url = '/SJHG/publicplat/member/memberlog/getTreeData';
        paramdata.onSuccess = function(res) {
          // console.log('-------------树形结构数据-----------------');
          if (res.data.ok && res.data.result) {
            //知识目录
            let catalogueTree = res.data.result.catalogueTree;
            this_.goodsCatalogueData = this_.getTreeData(catalogueTree);

            //知识分类
            let categoryTree = res.data.result.categoryTree;
            this_.goodsCategoryData = this_.getTreeData(categoryTree);

          } else {
            // let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      //解析树形结构数据
      getTreeData(obj) {
        let treeList = [];
        if (obj) {
          let nodelist = obj.childrens;
          if (nodelist === undefined || nodelist.length === 0) {
            let label_show = obj.name;
            if(obj.total&&obj.total!=0&&obj.total!='0'){
              label_show += '('+obj.total+')' ;
            }
            treeList.push({
              label: label_show,
              id: obj.id,
              children: [],
              pid: obj.parentId,
              pids: obj.parentIds
            });
          } else {
            nodelist.map((item, index) => {
              let label_show = item.name;
              if(item.total&&item.total!=0&&item.total!='0'){
                label_show += '('+item.total+')' ;
              }
              if(item.childrens&&item.childrens.length>0){
                treeList.push({
                  label: label_show,
                  id: item.id,
                  children: this.getTreeData(item),
                  pid: item.parentId,
                  pids: item.parentIds
                });
              }else{
                treeList.push({
                  label: label_show,
                  id: item.id,
                  children: [],
                  pid: item.parentId,
                  pids: item.parentIds
                });
              }

              // treeList.concat(this.getTreeData(item));
            });
          }
        }
        return treeList;
      },
      //搜素结果树节点点击
      handleNodeClick(data){
        this.searchResultTreeSelected = data.id;
        this.queryMsgList();
        console.log('tree drag enter: ', data);
      },
      //初始化页面查询参数数据源
      getLogTypsNumber() {
        let this_ = this;
        let paramdata = {};
        paramdata.data = {};
        paramdata.url = '/SJHG/publicplat/member/memberlog/searchLogCount';
        paramdata.onSuccess = function(res) {
          if (res.data.ok && res.data.result) {
            //日志数量
            let logCountMap = res.data.result.logCountMap;
            this_.logTypes.map((item, index) => {

                logCountMap.map((log_, index) => {
                  let tablename = log_.tablename;
                   if(log_.tablename == item.type){
                     item.number = log_.total;
                   }
                });

            });
          } else {
            // let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      }
    }
  })
</script>

<style lang="scss" scoped>
  p {
    margin: 0px;
    padding: 0px;
  }

  .knowledgeFootprint {
    width: 100%;
    height: 100%;
    padding-top: 20px;
  }

  .contair {
    width: 1280px;
    margin: 25px auto 0;
    display: flex;
  }

  >>>.el-date-editor .el-range-separator {
    color: #777;
    line-height: 27px;
  }

  >>>.el-range-editor .el-range-input {
    line-height: 27px;
  }

  >>>.el-tabs__item {
    height: 35px;
    line-height: 35px;
    color: #666;
  }

  >>>.el-tabs__item:hover {
    color: $color-primary;
  }

  >>>.el-tabs--card>.el-tabs__header .el-tabs__nav {
    border: none;
  }

  >>>.el-tabs--card>.el-tabs__header .el-tabs__item {
    margin-left: 6px;
    border: 1px solid #E4E7ED;
    background: #F2F2F2;
  }

  >>>.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background: #409eff;
    color: #ffffff;
  }

  >>>.el-input__inner {
    border-radius: $border-radius;
    height: 35px;
    line-height: 35px;
    color: #777;
  }

  >>>.el-tabs--card>.el-tabs__header .el-tabs__nav {
    border-radius: 0px;
  }

  >>>.el-collapse-item__header {
    height: 35px;
    line-height: 35px;
  }

  >>>.el-collapse-item__content {
    padding-bottom: 17px;
  }

  .left {
    width: 20%;
    background: #ffffff;
    border: 1px solid #cccccc;
  }

  .right {
    width: 80%;
    padding-left: 20px;
    border: 1px solid #cccccc;
    padding-right: 20px;
    border-left: none;
    box-sizing: border-box;
  }

  .titleList>li {
    height: 41px;
    line-height: 41px;
    font-size: 16px;
    padding: 0px 20px;
    color: #222;
  }

  .titleList>li:hover {
    color: $color-primary;
    cursor: pointer;
    background: $box-background-hover;
  }

  .titleList i {
    font-size: 24px;
    line-height: 50px;
  }

  .titleList .activeLi {
    color: $color-primary;
    background: $box-background-hover;
  }

  .rightDetail {
    width: 100%;
  }

  .timeBox {
    display: flex;
    margin-top: 0px;
    margin-bottom: 10px;
  }

  .name {
    display: flex;
    width: 60%;
  }

  .name>div:first-of-type {
    height: 35px;
    line-height: 35px;
    margin-right: 5px;
    width: 10%;
    color: #666;
    font-size: 14px;
  }

  .name>div:last-of-type {
    width: 87%;
  }

  >>>.name .el-input__inner {
    height: 35px;
    line-height: 35px;
    box-sizing: border-box;
    width: 100%;
  }

  .time {
    display: flex;
    width: 40%;
  }

  .timeText {
    width: 30%;
    height: 35px;
    line-height: 35px;
    color: #666;
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
    box-sizing: border-box;
  }

  .searchBox {
    display: flex;
  }

  .knowladge {
    display: flex;
    width: 30%;
  }

  .knowladge>div:first-of-type {
    width: 24%;
    height: 35px;
    line-height: 35px;
    color: #666;
    font-size: 14px;
  }

  .knowladgeType {
    display: flex;
    width: 30%;
  }

  .knowladgeType>div:first-of-type {
    width: 27%;
    height: 35px;
    line-height: 35px;
    color: #666;
    margin-left: 5px;
    font-size: 14px;
  }

  .pickData {
    width: 70%;
  }

  >>>.pickData .el-date-editor--datetimerange.el-input__inner {
    width: 100%;
  }

  .btnBox {
    width: 40%;
    text-align: right;
  }

  .btnBox>button {
    background: $color-primary;
    color: #ffffff;
    text-align: center;
    height: 35px;
    line-height: 35px;
    padding: 0px 20px;
    outline: none;
    border: 1px solid $color-primary;
    font-size: 14px;
    margin-left: 10px;
  }

  .btnBox>button:hover {
    cursor: pointer;
    background: $color-primary-light-1;
    border: 1px solid $color-primary-light-1;
  }

  .content {
    margin-top: 17px;
    display: flex;
  }

  >>>.el-tabs__nav {
    float: right;
  }

  .contairBox {
    display: flex;
  }

  .leftContent {
    width: 20%;
    padding-top: 40px;
  }

  >>>.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background: $color-primary;
  }

  .flexRow {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .flexRowBetween {
    justify-content: space-between;
  }

  .fn18 {
    font-size: 18px;
    color: #108DE9;
    margin-right: 10px;
  }

  .fn14 {
    font-size: 14px;
  }

  .mar10 {
    margin-right: 10px;
  }

  .resultContent {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow-y: auto;
  }

  .resultContent>div {
    box-sizing: border-box;
    width: 33.3%;
    padding: 5px;
  }

  .resuleBox {
    border: 1px solid $color-primary;
    box-sizing: border-box;
    padding: 2px 5px;
    position: relative;
  }

  .logoType {
    position: absolute;
    height: 60px;
    width: 60px;
    top: 5px;
    left: 5px;
  }

  .logoType>img {
    width: 100%;
  }

  .fn12 {
    font-size: 12px;
    color: #666;
    text-align: right;
    margin: 0 0 4px;
  }

  .image {
    height: 150px;
  }

  .image>img {
    height: 150px;
    width: 100%;
  }

  .typeName {
    display: inline-block;
    padding: 2px 6px;
    background: $color-primary;
    color: #fff;
    margin: 8px 0;
  }

  .margin0 {
    margin: 0;
    color: #666;
  }

  .OnTrial {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    border: 1px solid $color-primary;
    border-top: none;
  }

  .flex1 {
    flex: 1;
  }

  .obliqueLine {
    width: 0;
    height: 0;
    border-bottom: 30px solid $color-primary;
    border-left: 15px solid #F8F8F8;
  }

  .obliqueLine1 {
    width: 0;
    height: 0;
    border-top: 30px solid $color-primary;
    border-right: 15px solid transparent;
  }

  .bgcolor {
    background: $color-primary;
    color: #fff;
    text-align: right;
  }

  .bgcolor1 {
    background: #F8F8F8;
    color: $color-primary;
  }

  .price {
    color: #999999;
    width: 82px;
    text-align: center;
    text-decoration: line-through;
  }

  .bgcolor2 {
    background: $color-primary;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
  }

  .paging {
    display: flex;
    margin-top: -3px;
  }

  .paging>>>.el-pagination {
    display: block;
    margin: 15px auto;
  }

  .paging>>>.el-pager li.active {
    color: $color-primary;
  }

  .paging>>>.el-pager li {
    font-size: 18px;
    font-weight: normal;
    color: #666;
  }

  >>>.el-collapse-item__header {
    color: $color-primary;
    display: block;
  }

  >>>.el-collapse-item__arrow {
    margin-left: 10px;
  }

  .titleBox {
    border-bottom: 1px solid #e6e7ec;
    margin-bottom: 15px;
    display: flex;
    width: 1280px;
    height: 32px;
    margin: 0 auto;
  }

  .titleBox>p {
    line-height: 28px;
    height: 32px;
    font-size: 18px;
    color: #222;
  }

  .redBox {
    height: 18px;
    margin-top: 4px;
    background: $color-primary;
    width: 4px;
    margin-right: 4px;
  }

  .seatBox {
    height: 40px;
  }

  .rightContent {
    width: 100%;
  }

  .hand {
    cursor: pointer;
  }

  .el-dialog-div {
    height: 60vh;
    overflow: auto;
  }
  .topBox {
    display: flex;
    height: 40px;
    border: 1px solid rgb(0, 193, 222);
    padding: 0px 10px;
    margin-top: 10px;
  }

  .topBox>p {
    margin: 0px;
    padding: 0px;
    font-size: 12px;
    line-height: 40px;
    color: rgb(0, 193, 222);
  }

  .topBox>p:first-of-type {
    width: 95%;
    text-align: left;
  }

  .topBox>p:last-of-type {
    width: 5%;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/page/memberCenter/knowledgeFootprint.vue